import Filter from "bad-words"

let filter = new Filter()
filter.removeWords("sex")

export default filter
